// De tags die het LLM in zijn antwoord emit, en hoe je ze eruit haalt.
// Bewust vrij van `config` (en dus van `window`): de streamende chat draait deze
// functies op elke delta, en de tests ervoor moeten zonder DOM kunnen draaien.
// De backend heeft een spiegel hiervan in ca_project/project/chat_filters.py.

const FILTER_TAG = /<filters>([\s\S]*?)<\/filters>/;
export function parseFilterTag(text: string): Record<string, any> | null {
  const match = FILTER_TAG.exec(text);
  if (!match) return null;
  try {
    const parsed = JSON.parse(match[1]);
    return typeof parsed === "object" && parsed !== null ? parsed : null;
  } catch {
    return null;
  }
}

const OPEN_TAG = "<filters>";

// Haalt de filtertag uit de tekst. Ook tijdens het streamen bruikbaar: een tag
// die nog niet is afgesloten — of waarvan pas "<filt" binnen is — wordt ook
// verborgen, anders ziet de gebruiker de ruwe JSON voorbijkomen.
export function stripFilterTag(text: string): string {
  let out = text.replace(/<filters>[\s\S]*?<\/filters>\s*/, "");

  const open = out.indexOf(OPEN_TAG);
  if (open !== -1) return out.slice(0, open).trim();

  for (let i = OPEN_TAG.length - 1; i > 0; i--) {
    if (out.endsWith(OPEN_TAG.slice(0, i))) {
      out = out.slice(0, -i);
      break;
    }
  }
  return out.trim();
}
